import { render } from "./TheModal.vue?vue&type=template&id=f0d81a66&scoped=true&lang=pug&bindings={\"status\":\"setup\",\"changeModalStatus\":\"setup\",\"modal\":\"setup\",\"layout\":\"setup\",\"className\":\"setup\",\"type\":\"setup\",\"productId\":\"setup\",\"id\":\"setup\"}"
import script from "./TheModal.vue?vue&type=script&lang=js"
export * from "./TheModal.vue?vue&type=script&lang=js"

import "./TheModal.vue?vue&type=style&index=0&id=f0d81a66&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-f0d81a66"

export default script